module.exports = __webpack_public_path__ + "img/pie-chart.8efd03cd.png";